import type { AppDispatch } from '../app/store';
import type { PromptTagDefinition } from '../components/details/AiConfigNew/types';
import { BusinessDataModel } from '../models';
import { setPromptsAndAssistants, setPromptTagDefinitions } from '../reducers/aiConfigSlice';
import { setBookingListData } from '../reducers/bookingsSlice';
import { setBusinessData } from '../reducers/businessSlice';
import { setCustomersData } from '../reducers/customersSlice';
import { setNumbersData } from '../reducers/numbersSlice';

type PromptTagDefinitionLoader = (businessDomainId: number) => Promise<PromptTagDefinition[]>;

export const applyPortalBusinessData = async (
  dispatch: AppDispatch,
  businessData: BusinessDataModel,
  loadPromptTagDefinitions?: PromptTagDefinitionLoader
) => {
  dispatch(setBusinessData(businessData));
  dispatch(setBookingListData(businessData));
  dispatch(setNumbersData(businessData.businessPhoneNumbers ?? []));
  dispatch(setPromptsAndAssistants({ prompts: businessData.prompts ?? [], assistants: businessData.assistants ?? [] }));

  const businessDomainId = businessData?.business?.businessDomainId ?? 0;
  if (businessDomainId > 0 && loadPromptTagDefinitions) {
    try {
      const promptTagDefinitions = await loadPromptTagDefinitions(businessDomainId);
      dispatch(setPromptTagDefinitions(promptTagDefinitions ?? []));
    } catch (error) {
      console.error('Failed to load prompt tag definitions', error);
      dispatch(setPromptTagDefinitions([]));
    }
  } else {
    dispatch(setPromptTagDefinitions([]));
  }

  dispatch(setCustomersData(businessData.customers ?? []));
};
